"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const GetCandidateInfo_1 = require("./GetCandidateInfo");
const GetRecrutationInfo_1 = require("./GetRecrutationInfo");
const PostEndRecrutation_1 = require("./PostEndRecrutation");
const PostStartRecrutation_1 = require("./PostStartRecrutation");
__export(require("./GetRecrutationInfo"));
__export(require("./GetCandidateInfo"));
__export(require("./PostStartRecrutation"));
__export(require("./PostEndRecrutation"));
exports.API_ENDPOINTS = {
    GetCandidateInfoUrl: GetCandidateInfo_1.GetCandidateInfoUrl,
    GetRecrutationInfoUrl: GetRecrutationInfo_1.GetRecrutationInfoUrl,
    PostEndRecrutationUrl: PostEndRecrutation_1.PostEndRecrutationUrl,
    PostStartRecrutationUrl: PostStartRecrutation_1.PostStartRecrutationUrl
};
//# sourceMappingURL=index.js.map